module.exports = __webpack_public_path__ + "static/img/liz.582976f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/liz.jpg
// module id = oU0j
// module chunks = 0